import * as z from "zod/v4";

export const deleteTotes = {
  name: "deleteTotes" as const,
  input: z.object({ toteIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};

export type DeleteTotesInput = z.infer<typeof deleteTotes.input>;
